module.exports = __webpack_public_path__ + "img/2.e8d95ac0.jpg";